<template>
  <f7-page>
    <navbar :text="$t('LeftPanel_subtitle_optimalCropDistribution')" />
    <f7-block>
      <DxOptimalCropDistribution
        :gross-margin="mopecoModel.grossMargin"
        :gross-margin-deviation="mopecoModel.grossMarginDeviation"
        :best-optimization="mopecoModel.bestOptimization"
        :available-surface="mopecoModel.availableSurface"
        :total-surface="mopecoModel.totalSurface"
        :available-water="mopecoModel.availableWater"
        :irrigation-water="mopecoModel.totalIrrigation"
      />
    </f7-block>
    <f7-button
      class="dx-btn-cancel"
      raised
      type="default"
      text-color="grey"
      style="margin-top: 5px;"
      styling-mode="outlined"
      @click="$f7.views.main.router.navigate('/optimalCropDistributionAdvanced/');"
    >
      {{ $t('advanced_results') }}
    </f7-button>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex';
import DxOptimalCropDistribution from '../components/DxOptimalCropDistribution.vue';
import navbar from '../components/NavBar.vue';

export default {
  components: {
    DxOptimalCropDistribution,
    navbar,
  },
  computed: {
    ...mapState('Mopeco', ['mopecoModel']),
  },
};
</script>

<style>

</style>
